import { useScreenView } from '../../../../../utils/ScreenViewContext';
import ProfileOverview from './widgets/ProfileOverview';

interface VendorProfileProps {
  userType: string;
  currentPage: string;
  currentTab: string;
  setCurrentTab: (tab: string) => void;
  subTab: string;
  setSubTab: (tab: string) => void;
}

function VendorProfile({
  userType,
  currentPage,
  currentTab,
  setCurrentTab,
  subTab,
  setSubTab,
}: VendorProfileProps) {
  const { screenView } = useScreenView();

  const props = {
    userType,
    currentPage,
    currentTab,
    setCurrentTab,
    subTab,
    setSubTab,
  };

  const renderScreenView = (screenView: string) => {
    switch (screenView) {
      case 'desktop':
      case 'tablet':
      case 'mobile':
        return (
          <div className="h-full overflow-y-auto overflow-x-hidden px-4 sm:w-[95%] md:w-full lg:w-[1148px] lg:max-w-[1148px] lg:px-0">
            <div className="flex h-full w-full flex-col space-y-[16px] pt-[16px]">
              <ProfileOverview {...props} />
            </div>
          </div>
        );
    }
  };

  return <>{renderScreenView(screenView)}</>;
}

export default VendorProfile;
